// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4fe02ec8","239":"2110126c","386":"dce005cf","455":"841ddff9"}[chunkId] + ".chunk.js";
};